module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-tile-images/design-tile-07-4cf301a6da0c6dc45039eadb30910232.jpg";